import $ from 'jquery';

export default function subFormSection() {
    $('#subForm button[type="submit"]').click(function (el){

        el.preventDefault();

        $('#subForm .error').remove();

        var consentEmail = document.getElementById('cm-consentEmail');
        var consentTrack = document.getElementById('cm-consentTrack');
        var consentHorse = document.getElementById('cm-horse');
        var consentJock = document.getElementById('cm-jockey');
        var consentEq = document.getElementById('cm-eq');

        if(consentEmail.checked && consentTrack.checked && (consentHorse.checked || consentJock.checked || consentEq.checked)) {
            $('#subForm').submit();
        } else {

            if(!(consentEmail.checked && consentTrack.checked)) {
                $(this).parent().prepend('<p class="error" style="color: darkred;">You must consent to email and tracking.<br/><br/></p>')
            }

            if(!(consentHorse.checked || consentJock.checked || consentEq.checked)) {
                $(this).parent().prepend('<p class="error" style="color: darkred;">You must opt in a list.<br/><br/></p>')
            }
        }

        // return false;

    });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/subform.js